import type { SpreadsheetRowId } from '~/_shared/types/spreadsheetData/spreadsheetRow';

export type ExportReportToolState = Readonly<ExportReportInactiveState | ExportReportActiveState>;

type ExportReportInactiveState = {
  isActive: false;
  params: null;
};

type ExportReportActiveState = {
  isActive: true;
  params: ExportReportLocationParams | ExportReportPolygonParams;
};

export enum ExportReportActiveType {
  Location = 'Location',
  Polygon = 'Polygon',
}

export type ExportReportLocationParams = {
  type: ExportReportActiveType.Location;
  data: {
    markerId: SpreadsheetRowId;
    title: string;
  };
};

export type ExportReportPolygonParams = {
  type: ExportReportActiveType.Polygon;
  data: Record<string, unknown>;
};
